import React from 'react';
import { Box, Flex, Text, Image, HStack } from '@chakra-ui/react';
import { Tag, DisplayText } from '@spotoninc/nexus-react';
import { ArrowUpIcon, ArrowDownIcon } from '@spotoninc/nexus-web-assets';

const BusinessCard = ({ title, amount, image, percentChange }) => {
  // Format the amount with commas and 2 decimal places
  const formattedAmount = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);

  // Determine the color based on whether the change is positive or negative
  const isPositive = percentChange >= 0;
  const changeColor = isPositive ? 'green.500' : 'red.500';

  return (
    <Box
      width="auto"
      minWidth="min-content"
      maxWidth="100%"
      flexGrow={1}
      flexShrink={1}
      flexBasis="auto"
      p={4}
      borderRadius="lg"
      bg="#F4F7FA"
    >
      <Flex
        height="100%"
        width="auto"
        flexWrap="nowrap"
        justifyContent="space-between"
        minWidth="0"
      >
        {/* Left side - Text content */}
        <Flex
          direction="column"
          justify="space-between"
          flex="0 1 auto"
          minWidth="0"
          pr={4}
        >
          <Box width="auto" overflow="visible">
            <Text
              fontSize="18px"
              fontWeight="semibold"
              mb={0}
              whiteSpace="nowrap"
            >
              {title}
            </Text>
            <DisplayText
              size="extraSmall"
              style={{
                display: 'inline-block',
                whiteSpace: 'nowrap',
                overflow: 'visible',
              }}
            >
              {formattedAmount}
            </DisplayText>
          </Box>
          {/* TODO: Add this back in when the api is updated to actually return previous date ranges' data */}
          {/* <HStack width="100%">
            <Text fontSize="sm" color="gray.600" fontWeight="medium">
              vs. prev year
            </Text>
            <Tag
              fontSize="sm"
              color={changeColor}
              fontWeight="medium"
              variant={isPositive ? 'success' : 'danger'}
            >
              <Flex alignItems="center" gap={1}>
                {isPositive ? <ArrowUpIcon /> : <ArrowDownIcon />}
                {percentChange}%
              </Flex>
            </Tag>
          </HStack> */}
        </Flex>

        {/* Right side - Image */}
        <Flex flexShrink={0} width="90px" align="center" justify="flex-end">
          <Image
            src={image}
            alt={title}
            w="90px"
            h="90px"
            objectFit="contain"
          />
        </Flex>
      </Flex>
    </Box>
  );
};

export default BusinessCard;
